export default __webpack_public_path__ + "favicon-180x180.v2.b98854b89e1bc92bb21ff9fab3d67845.png";